module.exports = __webpack_public_path__ + "static/media/bg-img.e0b3d6cf.png";